module.exports = __webpack_public_path__ + "img/logo-confirmation.4fbfaf0a.svg";